import {FC} from 'react'
import {Languages} from '../../../components'

const AsideLanguageMenu: FC = () => {
  return (
    <div className={'d-flex flex-column p-4'}>
      <Languages />
    </div>
  )
}

export {AsideLanguageMenu}
